<template>
    <div class="col-12 btn-marg"
        v-if="$welcomeView.isAllowed('viewLinkToSection', to)" >
        <router-link role="button"
            :class="buttonName"
            class="btn3d btn btn-lg btn-block" :to="{ name: to}">
                <i class="fa" :class="iconName"></i> {{text}} </router-link>
    </div>
</template>

<script type="text/babel">
import { WelcomeViewPermiter } from '../../../router/perimeters/welcomeViewPermiter';

export default {
    name: 'welcome-navigation-link',
    props: {
        to: {
            type: [String, Object],
        },
        text: {
            type: String
        },
        buttonName: {
            type: String,
        },
        iconName: {
            type: String
        },
    },
    perimeters: [
        WelcomeViewPermiter
    ]
};
</script>

<style lang="scss" scoped>
  @import url("../../../styles/welcomeButtons.scss");
</style>
